import { combineReducers, configureStore } from '@reduxjs/toolkit';
import * as Sentry from "@sentry/react";
import { presentationChatApi } from "./services/presentationChat";
import { agentsApi } from "@frontdoor/agent-ui-assistive";
// reducers
// credential app - start
import credentialsReducer from './components/CredentialApp/reducers/credentialsSlice';
import credentialsAppSliceReducer from './components/CredentialApp/reducers/credentialAppSlice';
import presentationSliceReducer from './components/CredentialApp/reducers/presentationSlice';
// credential app - end
// company builder - start
import companyListsReducer from './components/CompanyBuilder/reducers/companyListsSlice';
import companyBuilderAppReducer from './components/CompanyBuilder/reducers/companyBuilderAppSlice';
// company builder - end
// middleware
import autoSaveMiddleware from './components/CredentialApp/middleware/autoSaveMiddleware';
import { agentTurnCompletedMiddleware } from './middleware/agentTurnCompletedMiddleware';
// rtk
import { pubApi } from './services/pub';
import { matchesApi } from './services/matches';
import { searchesApi } from './services/searches';
import { companyApi } from './services/company';
import { paymentsApi } from './services/payments';
import { execProjectsApi } from './services/execProjects';
import { accountResourceFilesApi } from './services/accountResourceFiles';
import { frontdoorApi } from './services/apis';
import { orgsApi } from './services/orgs';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options listed below
});

export const rootReducer = combineReducers({
  // credential app - start
  credentials: credentialsReducer,
  credentialsAppState: credentialsAppSliceReducer,
  presentation: presentationSliceReducer,
  // credential app - end
  // company builder - start
  companyLists: companyListsReducer,
  companyBuilderAppState: companyBuilderAppReducer,
  // company builder - end
  [pubApi.reducerPath]: pubApi.reducer,
  [matchesApi.reducerPath]: matchesApi.reducer,
  [searchesApi.reducerPath]: searchesApi.reducer,
  [companyApi.reducerPath]: companyApi.reducer,
  [paymentsApi.reducerPath]: paymentsApi.reducer,
  [execProjectsApi.reducerPath]: execProjectsApi.reducer,
  [accountResourceFilesApi.reducerPath]: accountResourceFilesApi.reducer,
  [frontdoorApi.reducerPath]: frontdoorApi.reducer,
  [orgsApi.reducerPath]: orgsApi.reducer,
  [agentsApi.reducerPath]: agentsApi.reducer,
  [presentationChatApi.reducerPath]: presentationChatApi.reducer,
});

export const sharedMiddleware = [
  pubApi.middleware,
  matchesApi.middleware,
  searchesApi.middleware,
  companyApi.middleware,
  paymentsApi.middleware,
  execProjectsApi.middleware,
  accountResourceFilesApi.middleware,
  frontdoorApi.middleware,
  orgsApi.middleware,
  agentsApi.middleware,
  presentationChatApi.middleware,
  agentTurnCompletedMiddleware,
] as const;

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .prepend(autoSaveMiddleware.middleware)
    .concat(...sharedMiddleware),
  enhancers: (getDefaultEnhancers) => {
    return getDefaultEnhancers().concat(sentryReduxEnhancer);
  },
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
